import React, { ReactNode } from 'react';
import ImageWithCaption from '../../components/Image/ImageWithCaption';
import { ImageInterface } from '../../types';
import Spacer from '../../helpers/Spacer';
import { Grid, GridItem } from '../../helpers';
import { colors, mixins } from '../../core/styles/theme/default';
import styled from '@emotion/styled';
import FactsModule, { FactsModuleProps } from '../FactsModule';

const StyledIntroFacts = styled(Grid)`
  .gatsby-image-wrapper {
    ${mixins.responsiveStyles({
      'aspect-ratio': {
        zero: '450 / 280',
        small: '735 / 460',
        medium: '975 / 540',
        large: '1190 / 620',
        wide: '1090 / 620',
        ultra: '1260 / 620',
      },
    })}
  }

  p {
    color: ${colors.grey700};
  }
`;

const IntroFacts = ({ leadText, leadImage, facts }: IntroFactsProps) => {
  if (!leadText && !leadImage && !facts) return null;

  const factsIntroProps = {
    gridItemSize: { zero: 12 },
    gridItemPush: { zero: 0 },
    burritoProps: {
      spacingCurve: 'kilo',
      leftSpace: true,
      rightSpace: true,
      backgroundOffset: false,
    },
  };

  return (
    <>
      <StyledIntroFacts columns={12}>
        {leadText && (
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <Spacer space="gamma" />
            {leadText}
            <Spacer space="mega" />
          </GridItem>
        )}
        {leadImage?.image && (
          <GridItem size={12} push={0}>
            {!leadText && <Spacer space="gamma" />}
            <ImageWithCaption
              data={{
                ...leadImage,
                imageSizes: {
                  0: [450, 280],
                  480: [735, 460],
                  768: [975, 540],
                  1024: [1190, 620],
                  1280: [1090, 620],
                  1440: [1260, 620],
                },
                loading: 'eager',
              }}
            />
          </GridItem>
        )}
      </StyledIntroFacts>
      {facts && <FactsModule {...facts} {...factsIntroProps} />}
    </>
  );
};

export type IntroFactsProps = {
  leadText: ReactNode;
  leadImage?: ImageInterface;
  facts?: FactsModuleProps;
};

export default IntroFacts;
